"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionStyle = exports.ErrorStyle = exports.FormContext = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
// create the form context
exports.FormContext = react_1.default.createContext(undefined);
exports.ErrorStyle = react_1.default.createContext(undefined);
exports.DescriptionStyle = react_1.default.createContext(undefined);
var ReactEasyForm = function (props) {
    var theme = styles_1.useTheme();
    var defaultErrorStyle = {
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
    };
    var descriptionStyle = {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
    };
    var errorStyle = props.errorStyle || defaultErrorStyle;
    return (react_1.default.createElement("div", { style: props.style },
        react_1.default.createElement(exports.FormContext.Provider, { value: props.form },
            react_1.default.createElement(exports.ErrorStyle.Provider, { value: errorStyle },
                react_1.default.createElement(exports.DescriptionStyle.Provider, { value: descriptionStyle },
                    react_1.default.createElement("div", null, props.children))))));
};
exports.default = ReactEasyForm;
